
import { Component, Vue } from 'vue-property-decorator'
import HomeNewsTitle from './HomeNewsTitle.vue'
import { NewsMixinManager } from './news-mixin/manager'
import { NewsMixinService } from './news-mixin/service'

@Component({
  components: {
    HomeNewsTitle
  }
})
export default class extends Vue {
  private manager = new NewsMixinManager(0, '', new NewsMixinService());
  private text = { title: '新闻动态', id: '23' };
  private text2 = { title: '资讯回顾', id: '99' };
  private selectId = '23';
  mounted () {
    this.manager.menuId = '23'
    this.manager.init()
    this.manager.informationReviewService()
  }

  detailmore (id: string) {
    if (this.selectId === '23') {
      window.location.href = '/detailPage.html?menuId=23'
    } else {
      window.location.href = '/detailImagePage.html'
    }
  }

  goLinkpage (url: string) {
    console.log(url)
    if (!url) { return }
    if (!url.includes('http://') && !url.includes('https://')) {
      url = 'https://' + url
    }
    window.open(url)
  }

  detail (item: any) {
    if (this.selectId === '23') {
      window.location.href = `/infoNews.html#/news/${item.id}/${0}`
    }
  }
}
